import gql from 'graphql-tag';

export const TRAFFICKING_FILTERS_FRAGMENT = gql`
  fragment traffickingFilters on TraffickingFilters {
    __typename
    adAccountNameList
    productType
    adProductList {
      operator
      values
    }
    dateFilter {
      label
      value {
        end {
          day
          hour
          month
          year
        }
        start {
          day
          hour
          month
          year
        }
        status
        timezone
      }
    }
    accountManager {
      label
      value
    }
    traffickerEmailList {
      label
      value
    }
    accountExecutive {
      label
      value
    }
    accountExecutiveList {
      label
      value
    }
    pacingRiskList
    hasMisalignedSchedule
    hasZeroDeliveryRisk
    generalPacingStatusList {
      operator
      values
    }
    reviewStatusList {
      operator
      values
    }
    adStatusList
    orderTypeList {
      operator
      values
    }
    lineItemStatusList
    lineItemSubStatusList
    tierNameList {
      operator
      values
    }
    priorityValueList {
      operator
      values
    }
    billableThirdPartyList
    publisherList {
      operator
      values
    }
    adTypeList {
      operator
      values
    }
    creativeTypeList
    creativeReviewList {
      operator
      values
    }
    currencyList {
      operator
      values
    }
    isCoppaOrCaru
    isMakegood
    isAddedValue
    frequencyCap
    buyerNameList {
      operator
      values
    }
    brandIdList {
      label
      value
    }
    excludeBrandIdList {
      label
      value
    }
    brandIdOperator {
      operator
      values {
        label
        value
      }
    }
    industryIdList {
      operator
      values {
        label
        value
      }
    }
    agencyIdList {
      operator
      values {
        label
        value
      }
    }
    isRotation
    isSequence
    selectedTab
    countryList {
      operator
      values
    }
    campaigns {
      searchTerm
      selectedRowIds
      sortBy {
        sort
        order
      }
    }
    lineItems {
      searchTerm
      selectedRowIds
      sortBy {
        sort
        order
      }
    }
    ads {
      searchTerm
      selectedRowIds
      sortBy {
        sort
        order
      }
    }
    dspNameList
    doNotTraffic
    lineItemTypeList {
      operator
      values
    }
    startDate {
      operator
      date
      startDate
      endDate
      direction
      value
      unit
      referenceDate
    }
    endDate {
      operator
      date
      startDate
      endDate
      direction
      value
      unit
      referenceDate
    }
    actualStartDate {
      operator
      date
      startDate
      endDate
      direction
      value
      unit
      referenceDate
    }
    createdDate {
      operator
      date
      startDate
      endDate
      direction
      value
      unit
      referenceDate
    }
    updatedDate {
      operator
      date
      startDate
      endDate
      direction
      value
      unit
      referenceDate
    }
    percentPacing {
      min
      max
      minOperator
      maxOperator
    }
    CPM {
      min
      max
      minOperator
      maxOperator
    }
    completionsRemaining {
      min
      max
      minOperator
      maxOperator
    }
    lineItemEndDate {
      operator
      date
      startDate
      endDate
      comparisonOperation
      duration
      unit
    }
    omsPackageNameList {
      operator
      values
    }
    sspList {
      operator
      values
    }
    costMethodList {
      operator
      values
    }
    customPacingApplied
    billableEventList {
      operator
      values
    }
    distributionPartnerList {
      operator
      values
    }
    percentDelivered {
      min
      max
      minOperator
      maxOperator
    }
    percentExpected {
      min
      max
      minOperator
      maxOperator
    }
    frontLoadPercent {
      min
      max
      minOperator
      maxOperator
    }
    yodaThreshold {
      min
      max
      minOperator
      maxOperator
    }
    impressions {
      min
      max
      minOperator
      maxOperator
    }
    completionGoal {
      min
      max
      minOperator
      maxOperator
    }
    completions {
      min
      max
      minOperator
      maxOperator
    }
    completionsAtRisk {
      min
      max
      minOperator
      maxOperator
    }
    deliveryGoal {
      min
      max
      minOperator
      maxOperator
    }
    revenueAtRisk {
      min
      max
      minOperator
      maxOperator
    }
    underpacingRevenue {
      min
      max
      minOperator
      maxOperator
    }
    buffer {
      min
      max
      minOperator
      maxOperator
    }
    weight {
      min
      max
      minOperator
      maxOperator
    }
    campaignBudget {
      min
      max
      minOperator
      maxOperator
    }
    budget {
      min
      max
      minOperator
      maxOperator
    }
    revenue {
      min
      max
      minOperator
      maxOperator
    }
    maxDuration {
      min
      max
      minOperator
      maxOperator
    }
    yodaPacingStatusList
    campaignStatusList
    timezoneList
    viewabilityVendorList
    billingCalendarList
    priorityNameList
    assetTagList
    brandCappingList
    brandCapping
    legalApprovedCreative
    needsFortDReview
    sequenceName
    rotationGroupName
    sequenceNumber {
      min
      max
      minOperator
      maxOperator
    }
  }
`;
